<template>
  <div class="companyBox">
    <Form ref="searchForm" :label-width="90" :model="formCustom" inline>
      <Form-item label="所属集团：" prop="groupName">
        <Input
          v-model="formCustom.groupName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="所属公司：" prop="companyName">
        <Input
          v-model="formCustom.companyName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="所属厂站：" prop="deptName">
        <Input
          v-model="formCustom.deptName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <br>
      <Form-item label="考核类目：" prop="evaluationCategory">
        <Input
          v-model="formCustom.evaluationCategory"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="状态：" prop="status">
        <Select v-model="formCustom.status" clearable filterable style="width: 200px">
          <Option v-if="roleType == 4" value="0">草稿</Option>
          <Option v-if="roleType == 4 || roleType == 3" value="1">待审核</Option>
          <Option value="2">未完成</Option>
          <Option value="3">已完成</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')"
        >重置
        </Button
        >
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button v-if="roleType == 4" type="primary" @click="addEvaluation">新建</Button>
    </div>
    <div>
      <Table
        :columns="companyColumns"
        :data="companyTableData"
        :loading="loading"
        aria-describedby=""
        aria-hidden="true"
        border
        @on-selection-change="selectionChange"
      >
        <template slot="action" slot-scope="{ row }">
          <Button
            v-if="roleType == 4"
            size="small"
            type="text"
            @click="check(row)"
          >查看
          </Button>
          <Button
            v-if="row.status == 0"
            size="small"
            type="text"
            @click="checks(row)"
          >编辑
          </Button>
          <Button
            v-if="row.status == 0"
            size="small"
            type="text"
            @click="publish(row)"
          >发布
          </Button>
          <Button
            v-if="row.status != 0"
            size="small"
            type="text"
            @click="goEmployee(row)"
          >去处理
          </Button>
          <Button
            v-if="row.status == 0"
            size="small"
            type="text"
            @click="deleteEvaluation(row)"
          >取消
          </Button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <p v-if="roleType == 4 || roleType == 3">{{
              row.status == 0 ? '草稿' : row.status == 1 ? '待审核' : row.status == 2 ? '未完成' : '已完成'
            }}</p>
          <p v-else>{{
              row.status == 0 ? '草稿' : row.status == 1 ? '未完成' : row.status == 2 ? '未完成' : '已完成'
            }}</p>
        </template>
      </Table>
      <Page
        ref="pages"
        :current="page"
        :total="total"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        @on-change="setCurrent"
        @on-page-size-change="setPage"
      ></Page>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" title="考评职工" width="1200px">
      <Form ref="searchFormEmployee" :label-width="90" :model="formCustomTable" inline>
        <Form-item label="所属公司：" prop="companyName">
          <Input
            v-model="formCustomTable.companyName"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <Form-item label="所属厂站：" prop="deptName">
          <Input
            v-model="formCustomTable.deptName"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <Form-item label="姓名：" prop="employeeRealName">
          <Input
            v-model="formCustomTable.employeeRealName"
            :maxlength="50"
            clearable
            style="width: 200px"
          ></Input>
        </Form-item>
        <br>
        <Form-item label="状态：" prop="status">
          <Select v-model="formCustomTable.status" clearable filterable style="width: 200px">
            <Option v-if="roleType == 4 || roleType == 3" value="1">待审核</Option>
            <Option value="2">未完成</Option>
            <Option value="3">已完成</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="handleSearchEmployee">查询</Button>
          <Button class="iviewButton" @click="handleResetEmployee('searchFormEmployee')"
          >重置
          </Button
          >
        </Form-item>
      </Form>
      <Table
        :border="true"
        :columns="columns"
        :data="tableData"
        :height="400"
        aria-describedby=""
        aria-hidden="true"
        style="width: 100%"
      >
        <template slot="action" slot-scope="{ row }">
          <Button
            size="small"
            type="text"
            @click="checkWorker(row)"
          >查看
          </Button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <p v-if="roleType == 4 || roleType == 3">{{
              row.status == 0 ? '草稿' : row.status == 1 ? '待审核' : row.status == 2 ? '未完成' : '已完成'
            }}</p>
          <p v-else>{{
              row.status == 0 ? '草稿' : row.status == 1 ? '未完成' : row.status == 2 ? '未完成' : '已完成'
            }}</p>
        </template>
      </Table>
      <Page
        ref="dialogpages"
        :current="dialogpage"
        :total="dialogtotal"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        @on-change="dialogsetCurrent"
        @on-page-size-change="dialogsetPage"
      ></Page>
    </el-dialog>
    <el-dialog :visible.sync="dialogWorkerVisible" title="考评职工记录" width="1200px">
      <Table
        :border="true"
        :columns="columnsWorker"
        :data="tableWorkerData"
        :height="400"
        aria-describedby=""
        aria-hidden="true"
        style="width: 100%"
      >
        <template slot="action" slot-scope="{ row }">
          <Button
            v-if="row.evaluationItem == '员工考评表'"
            size="small"
            type="text"
            @click="checksWorker(row)"
          >查看
          </Button>
          <Button
            v-if="(row.evaluationItem == '员工考评表' && (row.auditStatus == 4 || row.auditStatus == 1) && (roleType == 2 || roleType == 1 || roleType == 5)) || ((row.auditStatus == 1 || row.auditStatus == 4) && row.evaluationItem != '员工考评表' && roleType == 1)"
            size="small"
            type="text"
            @click="uploadFile(row)"
          >上传
          </Button>
          <Button
            v-if="(row.auditStatus == 1 || row.auditStatus == 4) && row.evaluationItem != '员工考评表' && roleType == 1"
            size="small"
            type="text"
            @click="downloadFile(row)"
          >下载
          </Button>
          <Button
            v-if="(row.evaluationItem == '员工考评表' && (row.auditStatus == 4 || row.auditStatus == 1) && (roleType == 2 || roleType == 1 || roleType == 5)) || ((row.auditStatus == 1 || row.auditStatus == 4) && row.evaluationItem != '员工考评表' && roleType == 1)"
            size="small"
            type="text"
            @click="auditWorker(row)"
          >提交审核
          </Button>
          <Button
            v-if="row.auditStatus == 2  && (roleType == 4 || roleType == 3)"
            size="small"
            type="text"
            @click="audit(row)"
          >审核
          </Button>
        </template>
        <template slot="auditStatus" slot-scope="{ row }">
          {{
            row.auditStatus == 1 ? '待提交' : row.auditStatus == 2 ? '待审核' : row.auditStatus == 3 ? '审核通过' : '审核拒绝'
          }}
        </template>
        <template slot="leaveUrl" slot-scope="{ row }">
          <Button v-if="(row.evaluationItem == '员工考评表' && row.employeeEvaluationUrl)
          || (row.evaluationItem == '各部门打分表' && row.departmentEvaluationUrl)
          || (row.evaluationItem == '员工互评表' && row.employeeMutualEvaluationUrl)
          || (row.evaluationItem == '用人部门打分表' && row.employmentEvaluationUrl)" size="small" type="text"
                  @click="leaveShow(row)">附件
          </Button>
        </template>
      </Table>
    </el-dialog>
    <el-dialog :visible.sync="dialogAuditVisible" title="审核">
      <Form :label-width="120" :model="asyncRoute">
        <FormItem label="审核结果：">
          <el-radio v-model="asyncRoute.pass" label="1">审核通过</el-radio>
          <el-radio v-model="asyncRoute.pass" label="2">审核拒绝</el-radio>
        </FormItem>
        <Form-item label="审核意见：">
          <Input
            v-model="asyncRoute.checkIdea"
            clearable
            style="width: 200px"
            type="textarea"
          ></Input>
        </Form-item>
      </Form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditclick">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogFormVisible" title="上传">
      <el-form :model="form">
        <el-form-item label="附件">
          <Upload ref="upload" :action="upAction" :format="['jpg','jpeg','png','pdf']"
                  :headers="getToken" :max-size="2048" :on-error="handleError"
                  :on-exceeded-size="handleMaxSize" :on-format-error="handleFormatError" :on-success="handleSuccess">
            <Button type="primary">上传</Button>
          </Upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    <addevaluation
      :isupload="isupload"
      :model="addRow"
      :select="select"
      :visible="visibleAdd"
      @cancel="handleCancelAdd"
      @successadd="successadd"
    />
    <fill-in
      :model="workerRow"
      :visible="visibleFillIn"
      @cancel="handleCancelFillIn"
      @save="save"
    />
  </div>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import fillIn from "./fillIn.vue";
import {
  companyEvaluationDelete,
  companyEvaluationEmployeeRecordAudit,
  companyEvaluationEmployeeRecordPage,
  companyEvaluationEmployeeRecordPut,
  companyEvaluationEmployeeRecordSubmitAudit,
  companyEvaluationPage,
  companyEvaluationPublish,
  pageCompanyEvaluationEmployee
} from "@/api/evaluation";
import addevaluation from "./addevaluation.vue"

export default {
  name: "company",
  data() {
    return {
      absenteeismUrl: '',
      dialogFormVisible: false,
      visibleAdd: false,
      select: false,
      visibleFillIn: false,
      addRow: {},
      dialogVisible: false,
      dialogTableVisible: false,
      dialogWorkerVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      dialogtotal: 0,
      dialogpage: 1,
      dialogloading: false,
      dialogWorkerloading: false,
      tableWorkerData: [],
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: "",
      formCustomTable: {},
      formCustom: {},
      asyncRoute: {
        pass: '1',
        checkIdea: ''
      },
      columnsWorker: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "职位", key: "employeePositionName", align: "center"},
        {title: "考评项", key: "evaluationItem", align: "center"},
        {title: "附件", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {title: "考评角色", key: "evaluationRole", align: "center"},
        {title: "状态", key: "auditStatus", align: "center", slot: "auditStatus"},
        {title: "审核意见", key: "auditIdea", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyColumns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属集团", key: "groupName", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "考核类目", key: "evaluationCategory", align: "center"},
        {title: "考评员", key: "evaluationRole", align: "center"},
        {title: "创建时间", key: "createTime", align: "center"},
        {title: "发送时间", key: "publishTime", align: "center"},
        {title: "状态", key: "status", align: "center", slot: "status"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属集团", key: "groupName", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "职位", key: "employeePositionName", align: "center"},
        {title: "状态", key: "status", align: "center", slot: "status"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
      dialogAuditVisible: false,
      roleType: '',
      companyAttendanceIds: '',
      val: new Date(),
      daylist: [],
      holidaylist: [],
      cutoffTime: '',
      isupload: false,
      workerRow: {},
      employeerow: {},
      isuploadWorker: false,
      attendanceDate: '',
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      upAction: this.$getImg + 'api/auth/file', // 上传图片网址
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
    }
  },
  components: {
    addevaluation,
    fillIn
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
    console.log(this.roleType)
  },
  methods: {
    downloadFile(row) {
      window.open(row.templatePath)
    },
    auditclick() {
      if (!this.asyncRoute.checkIdea && this.asyncRoute.pass == '2') {
        this.$message.error('请填写审核意见')
        return
      }
      let pass = true
      if (this.asyncRoute.pass == '2') {
        pass = false
      }
      companyEvaluationEmployeeRecordAudit({
        subjectId: this.workerRow.companyEvaluationEmployeeRecordId,
        pass: pass,
        checkIdea: this.asyncRoute.checkIdea,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.dialogAuditVisible = false
          this.handleSearchWorker()
          this.handleSearchEmployee()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    leaveShow(row) {
      console.log(row)
      if (row.evaluationItem == '员工考评表') {
        window.open(row.employeeEvaluationUrl, '_blank')
      }
      if (row.evaluationItem == '员工互评表') {
        window.open(row.employeeMutualEvaluationUrl, '_blank')
      }
      if (row.evaluationItem == '用人部门打分表') {
        window.open(row.employmentEvaluationUrl, '_blank')
      }
      if (row.evaluationItem == '各部门打分表') {
        window.open(row.departmentEvaluationUrl, '_blank')
      }
    },
    submit() {
      if (!this.absenteeismUrl) {
        this.$message.error('请先上传')
        return
      }
      let params = {
        companyEvaluationEmployeeRecordId: this.workerRow.companyEvaluationEmployeeRecordId,
      }
      if (this.workerRow.evaluationItem == '员工考评表') {
        params.employeeEvaluationUrl = this.absenteeismUrl
      }
      if (this.workerRow.evaluationItem == '员工互评表') {
        params.employeeMutualEvaluationUrl = this.absenteeismUrl
      }
      if (this.workerRow.evaluationItem == '用人部门打分表') {
        params.employmentEvaluationUrl = this.absenteeismUrl
      }
      if (this.workerRow.evaluationItem == '各部门打分表') {
        params.departmentEvaluationUrl = this.absenteeismUrl
      }
      companyEvaluationEmployeeRecordPut(params).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.dialogFormVisible = false
          this.handleSearchWorker()
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    },
    uploadFile(row) {
      this.workerRow = row
      if (this.$refs.upload != undefined) {
        this.$refs["upload"].clearFiles()
      }
      this.dialogFormVisible = true
      this.absenteeismUrl = ''
    },
    handleSuccess(response) {
      this.absenteeismUrl = this.$getImgFile + response.data
    },
    handleError(error, file) {
      this.$message.error(file.msg)
    },
    // 超出限制大小
    handleMaxSize() {
      this.$message.error('所传图片不能超过2M,请重新选择')
    },
    // 验证失败钩子
    handleFormatError() {
      this.$message.error('请上传正确的图片格式，仅支持jpg，jpeg，png三种格式')
    },
    cancelAudit() {
      this.dialogAuditVisible = false
      // this.asyncRoute.checkIdea = ''
    },
    auditWorker(row) {
      this.$confirmss('确认提交审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        companyEvaluationEmployeeRecordSubmitAudit({companyEvaluationEmployeeRecordId: row.companyEvaluationEmployeeRecordId}).then((res) => {
          if (res.data.success === false) {
            this.$message.warning(res.data.msg)
          } else {
            this.$message.success(res.data.msg)
            this.handleSearchWorker()
          }
          this.init()
        }).catch((error) => {
          this.$message.error(error.response.data.msg)
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    successadd() {
      this.init()
      this.visibleAdd = false
    },
    addEvaluation() {
      this.addRow = {}
      this.isupload = false
      this.select = false
      this.visibleAdd = true
    },
    save() {
      this.visibleFillIn = false
      this.handleSearchWorker()
    },
    handleCancelAdd() {
      this.visibleAdd = false
    },
    gofillIn(row) {
      this.row = row
      this.visibleFillIn = true
    },
    handleCancelFillIn() {
      this.visibleFillIn = false
    },
    // 初始化
    init() {
      this.loading = true
      companyEvaluationPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res);
      });
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = [];
        console.log(rows)
        rows.forEach((row) => {
          ids.push(row.companyAttendanceId);
        });
        this.companyAttendanceIds = ids.join(",");
      } else {
        this.companyAttendanceIds = ''
      }
    },
    check(row) {//查看详情
      this.addRow = row
      this.isupload = true
      this.visibleAdd = true
      this.select = true
    },
    checks(row) {//编辑详情
      this.addRow = row
      this.isupload = true
      this.select = false
      this.visibleAdd = true
    },
    goEmployee(row) {//查看职工
      this.row = row
      this.dialogTableVisible = true
      pageCompanyEvaluationEmployee({
        companyEvaluationId: row.companyEvaluationId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    checkWorker(row) {//查看职工详情
      this.employeerow = row
      this.dialogWorkerVisible = true
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: row.companyEvaluationEmployeeId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },

    checksWorker(row) {//查看详情
      this.workerRow = row
      this.visibleFillIn = true
    },
    deleteEvaluation(row) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          companyEvaluationDelete({companyEvaluationId: row.companyEvaluationId}).then((res) => {
            if (res.data.success === false) {
              this.$message.warning(res.data.msg)
            } else {
              this.$message.success(res.data.msg)
            }
            this.init()
          }).catch((error) => {
            this.$message.error(error.response.data.msg)
          })
        },
        onCancel: () => {
          this.$message.info('已取消删除')
        }
      })
    },
    // 查询
    handleSearchWorker() {
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: this.workerRow.companyEvaluationEmployeeId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },
    handleSearchEmployee() {
      pageCompanyEvaluationEmployee({
        current: 1,
        size: 10,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    handleSearch() {
      this.loading = true
      companyEvaluationPage({
        current: 1,
        size: this.pageSize,
        groupName: this.formCustom.groupName,
        companyName: this.formCustom.companyName,
        deptName: this.formCustom.deptName,
        evaluationCategory: this.formCustom.evaluationCategory,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },

    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    dialogchangeData(res) {
      this.dialogtotal = res.data.data.total;
      this.dialogsize = res.data.data.size;
      this.tableData = res.data.data.records;
      this.dialogloading = false;
    },
    dialogWorkerchangeData(res) {
      this.dialogWorkertotal = res.data.data.total;
      this.dialogWorkersize = res.data.data.size;
      this.tableWorkerData = res.data.data.records;
      this.dialogWorkerloading = false;
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearch();
    },
    // 重置
    handleResetEmployee(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearchEmployee();
    },
    // 改变页码
    dialogsetCurrent(val) {
      this.dialogloading = true;
      this.dialogpage = val;
      pageCompanyEvaluationEmployee({
        current: val,
        size: this.pageSize,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    // 改变每页条数
    dialogsetPage(val) {
      this.dialogloading = true;
      this.pageSize = val;
      pageCompanyEvaluationEmployee({
        current: 1,
        size: this.pageSize,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
        this.$refs["dialogpages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrent(val) {
      this.loading = true
      let data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.page = val;
      companyEvaluationPage({
        current: val,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      let data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.pageSize = val;
      companyEvaluationPage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    audit(row) {
      this.workerRow = row
      this.dialogAuditVisible = true
      this.asyncRoute.checkIdea = ''
      this.asyncRoute.pass = '1'
    },
    publish(row) {
      companyEvaluationPublish({companyEvaluationId: row.companyEvaluationId}).then(res => {
        if (res.data.success) {
          this.$message.success('发布成功')
          this.init()
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    }
  }
}
</script>
<style lang="less">
.red {
  background-color: rgba(243, 12, 1, 0.48);
  color: rgb(0, 0, 0);
  padding: 8px;
}

.green {
  background-color: rgba(66, 165, 111, 0.5);
  padding: 8px;
  color: rgba(55, 55, 55);
}

.el-calendar-table td .el-calendar-day {
  padding: 0;
}

.el-calendar__header {
  display: none
}
</style>
